export function getRangedArray(start: number, end: number, exit: number) {
  let result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
    if (i >= exit) break;
  }
  return result;
}
